/* eslint-disable @typescript-eslint/naming-convention*/
export enum SUBMENUS {
  SERVICES = 'services',
  BLOG = 'blog',
  CAREERS = 'careers',
  TOOLS = 'tools',
}
/* eslint-enable @typescript-eslint/naming-convention*/

export const submenusWhichAction = {
  services: 'setServicesHover',
  blog: 'setBlogHover',
  tools: 'setToolsHover',
  careers: 'setCareersHover',
};

export const submenuActionStateValues = {
  setServicesHover: 'servicesHover',
  setBlogHover: 'blogHover',
  setToolsHover: 'toolsHover',
  setCareersHover: 'careersHover',
};
